(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.property.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color text-size]]
   [garden.units :refer [px]]))

(defn h3
  []
  (with-meta
    {:padding        "12px 0"
     :font-size      "14px"
     :letter-spacing "2.2px"
     :font-weight    "bold"
     :min-height     "45px"
     :line-height    "1.5"
     :text-transform "uppercase"}
    {}))

(defn select-row
  []
  (with-meta
    {:padding       "6px"
     :margin-bottom "8px"
     :display       :flex
     :align-items   :center
     :gap           :12px
     :background    (theme/color [:page-bg :bg])
     :border-radius :8px}
    {}))

(defn select
  []
  (with-meta
    {:width        "60px"
     :height       "30px"
     :border-width "1px"
     :border-style "solid"
     :border-color (theme/color [:select-input :container :border])}
    {}))

(defn select-wide
  []
  (with-meta
    {:width        "120px"
     :height       "30px"
     :border-width "1px"
     :border-style "solid"
     :border-color (theme/color [:select-input :container :border])}
    {}))

(defn select-label
  []
  (with-meta
    {:display     :flex
     :align-items :center
     :gap         :8px
     :font-weight :600}
    {}))

(defn text-value
  []
  (with-meta
    {:padding "12px"}
    {}))

(defn certification-logo
  [selected?]
  (with-meta
    (merge {:max-width  "100px"
            :max-height "80px"}
           (when-not selected?
             {:filter "grayscale(100%) brightness(0.5)"}))
    {}))

(defn energy-performance-certificate-list
  []
  (with-meta
    {:padding-bottom "1em"}
    {}))

(defn energy-performance-certificate-item
  []
  (with-meta
    {:padding-bottom "4px"
     :display        "flex"
     :flex-direction "row"}
    {}))

(defn bar-container
  []
  (with-meta
    {:flex "0 0 auto"}
    {}))

(defn energy-bar
  [cls]
  (with-meta
    {:height "30px"}
    {}))

(defn energy-labels
  []
  (with-meta
    {:flex         "1 1 auto"
     :padding-left "12px"}
    {}))

(defn energy-label
  [small?]
  (with-meta
    {:font-size   (if small?
                    "12px"
                    "14px")
     :line-height (if small?
                    "12px"
                    "25px")}
    {}))

(defn table
  []
  (with-meta
    {:font-size   "12px"
     :line-height "12px"}
    {}))

(defn th
  []
  (with-meta
    {:font-size    "12px"
     :line-height  "12px"
     :padding      "8px"
     :border-width :1px
     :border-style :solid
     :border-color (theme/color [:table :border])
     :background   (theme/color [:table :th :bg])}
    {}))

(defn td
  []
  (with-meta
    {:font-size    "12px"
     :line-height  "12px"
     :padding      "6px 8px"
     :border-width :1px
     :border-style :solid
     :border-color (theme/color [:table :border])}
    {}))

(defn row
  []
  (with-meta
    {:display     :flex
     :align-items :center
     :gap         :8px}
    {}))

(defn input
  []
  (with-meta
    {:width :100%}
    {}))


